export default {
  NotificationLog: "NotificationLog",
  SendNotification: "SendNotification",
};